import COUNTRIES_ISO from './Countries';

export const lookupBrandLogo = (brand, brandsList) => {
  let brandSplited = brand.toLowerCase().split(/\s/);

  let brandLogo = brandsList.find((o) => o.names.find((l) => l === brandSplited.join(' ')));
  while (brandSplited.length > 0 && !brandLogo) {
    brandSplited.pop();
    brandLogo = brandsList.find((o) => o.names.find((l) => l === brandSplited.join(' ')));
  }

  if (!brandLogo) {
    brandLogo = "https://cdn.anubesport.com/timing/vehicle-logos/car/default.car.png";
  } else {
    brandLogo = "https://cdn.anubesport.com/timing/vehicle-logos/car/" + brandLogo.image + ".car.png";
  }
  return brandLogo;
};

export const lookupAlpha3FromFlagUrl = (url) => {
  console.log(url);
  if (!url) return '';
  const match = url.match(/\/flags\/([a-z]{2})\.png$/);
  if (!match) return '';
  const alpha2 = match[1].toUpperCase();
  const c = COUNTRIES_ISO.find(c => c.alpha2 === alpha2);
  return c ? c.alpha3 : '';
};

export const lookupFlagUrl = (code) => {
  console.log(code);
  const c = COUNTRIES_ISO.find(c => c.alpha3 === code);
  if (c) return `https://cdn.anubesport.com/timing/flags/${c.alpha2.toLowerCase()}.png`;
};

export const flagEmoji = (alpha3) => {
  const c = COUNTRIES_ISO.find(c => c.alpha3 === alpha3);
  if (!c) return '';
  return c.alpha2.toUpperCase().split('').map(ch =>
    String.fromCodePoint(0x1F1E6 - 65 + ch.charCodeAt(0))
  ).join('');
};

export const formatTimeInput = (totalSeconds) => {
  if (totalSeconds === null || totalSeconds === undefined || totalSeconds === '') return '';
  const sec = Number(totalSeconds);
  if (isNaN(sec) || sec === 0) return '';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  const hh = Math.round((sec - Math.floor(sec)) * 100);
  return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}.${String(hh).padStart(2, '0')}`;
};

export const parseTimeInput = (str) => {
  if (!str) return 0;
  const parts = str.split(':');
  let h = 0, m = 0, sFull = '0';
  if (parts.length === 3) { h = parseInt(parts[0]) || 0; m = parseInt(parts[1]) || 0; sFull = parts[2]; }
  else if (parts.length === 2) { m = parseInt(parts[0]) || 0; sFull = parts[1]; }
  else { sFull = parts[0]; }
  const sParts = sFull.split('.');
  const s = parseInt(sParts[0]) || 0;
  const frac = sParts[1] ? parseInt(sParts[1].padEnd(2, '0').slice(0, 2)) / 100 : 0;
  return h * 3600 + m * 60 + s + frac;
};

export const formatTime = (totalSeconds) => {
  if (totalSeconds === null || totalSeconds === undefined) return '';
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  const tenth = Math.round((totalSeconds - Math.floor(totalSeconds)) * 10);
  const hhPart = h > 0 ? `${h}:` : '';
  return `${hhPart}${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}.${tenth}`;
};
